{{data.title}}

{{data.message}}

<button mat-flat-button id="yes-button" [mat-dialog-close]="true" color="warn">Ja</button>
<button mat-flat-button id="no-button" [mat-dialog-close]="false">Nein</button>
